import {css, StyleSheet} from 'aphrodite';
import React, {useMemo} from 'react';

import {
  TOO_MANY_TRIAL_SAMPLES_MESSAGE,
  TOO_MANY_DILUTION_FACTORS_MESSAGE,
} from 'samples/plate-maps/integrations/procedures/PlateMapTestOrderUtils';
import {PlateMap} from 'samples/plate-maps/PlateMapConstants';
import {wellHasTooManyDilutionFactors, wellHasTooManyTrialSamples} from 'samples/plate-maps/PlateMapUtil';
import {FONT_PROXIMA_13} from 'styles/FontConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import {InlineBannerType} from 'ui-library/banners/InlineBanner';
import InlineBannerStack from 'ui-library/banners/InlineBannerStack';
import {GRAY_DARKER} from 'ui-library/Colors';

interface TestDilutionFactorLayerDisplayProps {
  plateMap: PlateMap;
}

export default function TestDilutionFactorLayerDisplay({
  plateMap,
}: TestDilutionFactorLayerDisplayProps): JSX.Element {
  const previewHasWellsWithTooManyTrialSamples = useMemo(
    () => plateMap.wells.some((well) => wellHasTooManyTrialSamples(well)),
    [plateMap]
  );
  const previewHasWellsWithMultipleDilutions = useMemo(
    () =>
      plateMap.wells.some((well) => wellHasTooManyDilutionFactors(well, plateMap.testOrderDilutionInfoById)),
    [plateMap]
  );
  const bannerStackMessages: Array<string> = [];
  if (previewHasWellsWithTooManyTrialSamples) {
    bannerStackMessages.push(TOO_MANY_TRIAL_SAMPLES_MESSAGE);
  }
  if (previewHasWellsWithMultipleDilutions) {
    bannerStackMessages.push(TOO_MANY_DILUTION_FACTORS_MESSAGE);
  }

  return (
    <div {...getTestProps({component: 'TestDilutionFactorLayerDisplay', element: 'root'})}>
      <p className={css(styles.helpText)}>
        Values are automatically set based on clinical samples in planned contents
      </p>
      {bannerStackMessages.length > 0 && (
        <InlineBannerStack
          messages={bannerStackMessages.map((text) => ({
            bannerType: InlineBannerType.WARNING,
            text,
          }))}
        />
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  helpText: {
    ...FONT_PROXIMA_13,
    color: GRAY_DARKER,
  },
});
